import React from "react";
import ForgotPassword from "../../components/forgot-password";

export default function ForgotPasswordPage() {
  return (
   <ForgotPassword></ForgotPassword>
  )
}